export const APP_ROLES = {
  UNIVERSITY_STANDARD_USER: 'UniversityStandardUser',
  TRAIN_YOUR_TEAM: 'TrainYourTeam'
};

export const ROUTE_IDS = {
  UNIVERSITY_PAGE: 'university_page'
};